import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import {AlgemeneTip} from '../algemene-tip';
import {DialogService} from '../../core/dialog/dialog.service';
import {filter} from 'rxjs/operators';
import User from '../../core/auth/user';

@Component({
    selector: 'zah-algemene-tips',
    templateUrl: './algemene-tips.component.html',
    styleUrls: ['./algemene-tips.component.scss'],
    standalone: false
})
export class AlgemeneTipsComponent {
  private dialogService = inject(DialogService);

  @Input()
  algemeneTips: Array<AlgemeneTip>;
  @Input()
  user: User;
  @Output()
  algemeneTipAdded: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  algemeneTipEdited: EventEmitter<[AlgemeneTip, string]> = new EventEmitter<[AlgemeneTip, string]>();
  @Output()
  algemeneTipDeleted: EventEmitter<AlgemeneTip> = new EventEmitter<AlgemeneTip>();

  getAlgemeneTipId(index: number, algemeneTip: AlgemeneTip): string {
    return algemeneTip.getId();
  }

  canAddAlgemeneTips(): boolean {
    return this.user.isTherapeut() || this.user.isRegioverantwoordelijke();
  }

  onTipClick(algemeneTip: AlgemeneTip): void {
    this.dialogService.showInformation(algemeneTip.getContent());
  }

  onAddClick(): void {
    this.dialogService
      .askText({
        label: 'Nieuwe tip',
        placeholder: 'Voer een nieuwe tip in',
        confirmLabel: 'Bewaar',
      })
      .subscribe(tip => this.algemeneTipAdded.emit(tip));
  }

  onEditClick(algemeneTip: AlgemeneTip): void {
      this.dialogService.askText({
        label: 'Tip wijzigen',
        placeholder: 'Wijzig tip',
        text: algemeneTip.getContent(),
        confirmLabel: 'Wijzigen'
      }).subscribe(content => this.algemeneTipEdited.emit([algemeneTip, content]));
  }

  onDeleteClick(algemeneTip: AlgemeneTip): void {
    this.dialogService
      .askConfirmation({message: 'Ben je zeker dat je de tip wil verwijderen?'})
      .pipe(filter(confirmation => confirmation))
      .subscribe(() => this.algemeneTipDeleted.emit(algemeneTip));
  }
}
